/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserGroupAssignmentUserUserType } from './UserGroupAssignmentUserUserType';
import {
    UserGroupAssignmentUserUserTypeFromJSON,
    UserGroupAssignmentUserUserTypeFromJSONTyped,
    UserGroupAssignmentUserUserTypeToJSON,
    UserGroupAssignmentUserUserTypeToJSONTyped,
} from './UserGroupAssignmentUserUserType';

/**
 * 
 * @export
 * @interface UserGroupAssignmentUser
 */
export interface UserGroupAssignmentUser {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    user_type?: UserGroupAssignmentUserUserType;
    /**
     * 
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the UserGroupAssignmentUser interface.
 */
export function instanceOfUserGroupAssignmentUser(value: object): value is UserGroupAssignmentUser {
    return true;
}

export function UserGroupAssignmentUserFromJSON(json: any): UserGroupAssignmentUser {
    return UserGroupAssignmentUserFromJSONTyped(json, false);
}

export function UserGroupAssignmentUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignmentUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'title': json['title'] == null ? undefined : json['title'],
        'user_type': json['user_type'] == null ? undefined : UserGroupAssignmentUserUserTypeFromJSON(json['user_type']),
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
    };
}

export function UserGroupAssignmentUserToJSON(json: any): UserGroupAssignmentUser {
    return UserGroupAssignmentUserToJSONTyped(json, false);
}

export function UserGroupAssignmentUserToJSONTyped(value?: UserGroupAssignmentUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'title': value['title'],
        'user_type': UserGroupAssignmentUserUserTypeToJSON(value['user_type']),
        'photo_url': value['photo_url'],
    };
}

